export default {
  sections: {
    state: {
      title: 'Stato',
      fields: {
        pickup_visible: {
          label: 'Ritiro visibile',
        },
        has_pickup: {
          label: 'Ritiro',
        },
      },
    },
    scheduled_orders: {
      title: 'Ordini programmati',
      fields: {
        has_scheduled_orders: {
          label: 'Consenti ai clienti di ordinare in anticipo per orari specifici?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Tempo minimo (minuti) di anticipo per programmare ordini di <strong>ritiro</strong>',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Ultimo orario utile per ordinare il <strong>ritiro</strong> (minuti prima della chiusura)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Tempo di preparazione per ordini di ritiro',
      fields: {
        average_order_preparation_time_min: {
          label: 'Tempo di preparazione in minuti',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'fino a',
          placeholder: 'Opzionale',
        },
      },
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    at_least_one_order_method_required:
      "Almeno 1 metodo d'ordine (programmato o immediato) deve essere attivo. Non puoi disabilitarli entrambi.",
  },
};
